__turbopack_context__.v({
  "className": "BFKNXq_className",
  "variable": "BFKNXq_variable",
});
